class productDetailTabs extends HTMLElement {
  constructor() {
    super();
    const tabs = this.querySelectorAll('[data-tab-target]');
    const tabContents = this.querySelectorAll('[data-tab-content]')
    tabs.forEach(tab =>
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        const tabTarget =  tab.getAttribute("data-tab-target")
        const target = this.querySelector(tabTarget)
        tabContents.forEach(tabContent => {
          tabContent.classList.remove('active');
          const tabID = tabContent.getAttribute("data-tab-id");
          if(tabID == tabTarget) {
            tabContent.classList.add('active');
          }
        })
        tabs.forEach(tab => {
          tab.classList.remove('active')
        })
        tab.classList.add('active');
      })
    )
  }
}
customElements.define('product-detail-tabs', productDetailTabs);